import { t } from '../../../languages';

import { Button, Spin } from 'antd';
import AvatarPicker from '../../User/AvatarPicker';


// Opened -> wait students to join
const StudentCompetitionStage2 = ({ lang, theCompetition, handleReady, avatar, updateAvatar, studentInCompetition }) => {
    const students = theCompetition ? theCompetition.participants : null;
    const numStudents = students ? students.length : 0;

    const handleAvatarChange = (anV) => {
        updateAvatar(anV);
    }

    return <>
        <div className="student-join">
            <div>
                {studentInCompetition ? null : <h2>{t(lang, 'joinCompetition')}</h2>}
                <AvatarPicker lang={lang} handleChange={handleAvatarChange} selected={avatar} canChange={!studentInCompetition} />
                {studentInCompetition ? null : <Button type="primary" className="button-blue" onClick={handleReady}>
                    {t(lang, 'ready')}
                </Button>}
                {studentInCompetition ? <h2>{t(lang, 'youarein')}</h2> : null}
            </div>
            {studentInCompetition ? <div className='waiting'>
                <h3 className="code">{t(lang, 'waitingcompetitionstart')}</h3>
                <Spin size="large" className="spinner" />
            </div> : null}
        </div>

        {/* <StudentList lang={lang} students={students} /> */}

    </>;
}

export default StudentCompetitionStage2;